// R38 — THE TWO ROUTES A RENAME TRAVELS, AND THE ONE ANSWER EACH GIVES BACK.
//
// R8's precedent (`attachments.ts`): a one-line URL law is worth its own module exactly when a gate
// can then hold it against the server's REAL route across a boundary. Both of these are contracts
// with a route in `server/index.js`, and both of them are silent when wrong — a rename posted to a
// path the server does not answer comes back 404, which this code reads as "could not rename" and
// hands the member a sentence about her reading rather than about a broken client.
//
// THE SHAPE THEY SHARE, AND IT IS R35's HONESTY HALF: the STORED title comes back, never the string
// we sent, and `null` means it did not happen. A handler that cannot report failure makes the
// control's failure sentence unreachable code, and the row keeps a name the database never took.
export function renameReportPath(id: string | number) { return `/api/rooms/report/${id}/rename`; }
export function renameConversationPath(id: string | number) { return `/api/lala/conversations/${id}`; }

async function postTitle(path: string, title: string): Promise<string | null> {
  try {
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data?.ok === false) return null;
    // The server's own stored title where it sends one back (it cleans and caps), ours otherwise.
    return String(data?.title || title);
  } catch {
    return null;
  }
}

// A saved report, anywhere it appears: My Room's four lists and the shelf drawer's card are the same
// row of the same table, so they rename through the same route.
export function renameSavedReport(id: string | number, title: string) {
  return postTitle(renameReportPath(id), title);
}

// An Ask Lala thread. Titled `text.slice(0, 48)` of her first message until she renames it, which
// until R38 she could not do: the route and the client helper both existed and nothing called either.
export function renameConversation(id: string | number, title: string) {
  return postTitle(renameConversationPath(id), title);
}
